<template>
  <div>
    <DailyBeetNavBar />
    <VContent class="view-content">
      <VContainer fluid pa-0>
        <BaseThemeComponent name="GlobalNotice" />
        <slot />
      </VContainer>
    </VContent>
    <Footer />
  </div>
</template>

<script>
import DailyBeetNavBar from '@dailyBeet/DailyBeetNavBar'
import Footer from '@components/Footer'

export default {
  components: { DailyBeetNavBar, Footer },
}
</script>
<style lang="scss">
@import '@themeStyles/DailyBeet.scss';
</style>
